import { html } from 'lit';

/**
 * Generates a safe triangular area within a given panel.
 * @param panel - The HTML element representing the dropdown-panel.
 * @param isRightStart - Boolean indicating if the triangle starts from the right.
 * @param mouse - Object containing the x and y coordinates of the mouse.
 * @returns An SVG element representing the safe triangular area.
 */
export class SafeTriangle {
  generateSafeTriangle(panel: HTMLElement, isRightStart: boolean, mouse: { x: number; y: number }) {
    const { height: panelHeight, x: panelX, y: panelY, right: panelRight } = panel.getBoundingClientRect();
    const svgWidth = isRightStart ? panelX - mouse.x + 2 : mouse.x - panelRight + 2;

    return html`
      <svg
        style="
            position: fixed;
            width: ${svgWidth}px;
            height: ${panelHeight}px;
            pointer-events: none;
            cursor: pointer;
            top: ${panelY}px;
            ${isRightStart ? `left: ${mouse.x - 1}px` : `right: ${window.innerWidth - mouse.x - 1}px`}"
      >
        <path
          pointer-events="auto"
          fill="rgba(0, 0, 0, 0)"
          d="${isRightStart
            ? `M ${svgWidth}, 0 
                     L ${svgWidth}, ${panelHeight}  
                     L ${mouse.x - panelX + svgWidth - 2}, ${mouse.y - panelY} z`
            : `M 0, 0
                     L ${0}, ${panelHeight}  
                     L ${svgWidth}, ${mouse.y - panelY} z`}"
        />
      </svg>
    `;
  }
}
